import styled from "styled-components";

/**
 * Componente ContainerDetailsFlights
 *
 * Container principal dos detalhes de resultados dos voos.
 */
export const ContainerDetailsFlights = styled.div`
  flex-direction: column;
  display: flex;
`;

/**
 * Componente StyledDetailsHeader
 *
 * Div para o cabeçalho dos detalhes de resultados dos voos.
 */
export const StyledDetailsHeader = styled.div`
  /* gap: ${({ theme }) => theme.spacing(2)}; */
  display: flex;
`;

/**
 * Componente StyledDetailsFlight
 *
 * Div para o detalhe do voo.
 */
export const StyledDetailsFlight = styled.div`
  display: flex;
  align-items: center;
  & > svg {
    margin-top: ${({ theme }) => theme.spacing(-0.5)};
    stroke-width: 2;
  }
`;

/**
 * Componente PassengersContent
 *
 * Div para o conteúdo de passageiros.
 */
export const PassengersContent = styled.div`
  margin-left: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(2)};
  display: flex;

  & > span {
    gap: ${({ theme }) => theme.spacing(1)};
    align-items: center;
    display: flex;
  }
`;

/**
 * Componente ContainerDatesFlight
 *
 * Div para as datas do voo.
 */
export const ContainerDatesFlight = styled.div<{ isColumn?: boolean }>`
  display: flex;
  gap: ${({ theme, isColumn }) => theme.spacing(isColumn ? 0.5 : 2)};
  flex-direction: ${({ isColumn }) => (isColumn ? "column" : "row")};
`;

/**
 * Componente StyledDatesFlight
 *
 * Div para as datas do voo.
 */
export const StyledDatesFlight = styled.div`
  gap: ${({ theme }) => theme.spacing(1)};
  display: flex;
`;
